import React from "react";
import {
  EmptyStateHourlyTracking,
  EmptyStateMissionTimeSheetPeriod,
} from "../../assets/icons";

/** Illustration et typo communes (paramètres Secteurs / Postes, vide Workfully). */
const settingsEmptyLogo = (
  <div className="mx-auto flex h-[72px] w-[72px] shrink-0 items-center justify-center">
    <EmptyStateHourlyTracking wh={72} />
  </div>
);

const SETTINGS_EMPTY_TITLE_CLASS =
  "mt-4 font-medium text-[14px] leading-snug text-gray-900";

const SETTINGS_EMPTY_DESCRIPTION_CLASS =
  "mt-2 font-normal text-[14px] leading-snug text-gray-700";

const EmptyState = ({ type, custom }) => {
  const logo = {
    hourly_tracking: (
      <div className={"mx-auto my-2"}>
        <EmptyStateHourlyTracking wh={256} />
      </div>
    ),
    settings_sectors: settingsEmptyLogo,
    settings_postes: settingsEmptyLogo,
    mission_time_sheet_period: (
      <div className={"mx-auto my-2"}>
        <EmptyStateMissionTimeSheetPeriod wh={120} />
      </div>
    ),
    activity: (
      <div className={"mx-auto my-2"}>
        <EmptyStateHourlyTracking wh={256} />
      </div>
    ),
  };

  const title = {
    hourly_tracking: "Pas de missions disponible",
    settings_sectors: "Aucun secteur",
    settings_postes: "Aucun poste",
    mission_time_sheet_period: "Aucun pointage disponible",
    activity: "Aucune activitée disponible",
  };

  const description = {
    hourly_tracking:
      "Importez des missions pour les consulter sur votre espace Workflow.",
    settings_sectors:
      "Créez des secteurs pour structurer vos missions et rattacher les membres aux bons périmètres.",
    settings_postes:
      "Créez des postes pour catégoriser vos shifts par fonction (chef de chantier, manutentionnaire, …).",
    mission_time_sheet_period: "Il n y a pas de pointages pour ce jour.",
    activity: "Vous n'avez pas encore d'activités.",
  };

  const button = {
    hourly_tracking: "",
    settings_sectors: "",
    settings_postes: "",
    mission_time_sheet_period: "",
    activity: "",
  };

  const titleClassName = {
    hourly_tracking: "font-medium ft-xl text-[#5C616D]",
    settings_sectors: SETTINGS_EMPTY_TITLE_CLASS,
    settings_postes: SETTINGS_EMPTY_TITLE_CLASS,
    mission_time_sheet_period: "font-medium ft-xl text-[#5C616D]",
    activity: "font-medium ft-xl text-[#5C616D]",
  };

  const descriptionClassName = {
    hourly_tracking: "font-normal ft-b mt-2 text-[#757575]",
    settings_sectors: SETTINGS_EMPTY_DESCRIPTION_CLASS,
    settings_postes: SETTINGS_EMPTY_DESCRIPTION_CLASS,
    mission_time_sheet_period: "font-normal ft-b mt-2 text-[#757575]",
    activity: "font-normal ft-b mt-2 text-[#757575]",
  };

  return (
    <>
      <div className={"max-w-[535px] m-auto text-center p-3"}>
        <div className={"flex justify-center"}>{logo[type]}</div>
        <div className={titleClassName[type]}>{title[type]}</div>
        <div className={descriptionClassName[type]}>{description[type]}</div>
        <div className={"flex flex-col"}>
          <div className={"mx-auto"}>{button[type]}</div>
          <div className={"mx-auto"}>{custom}</div>
        </div>
      </div>
    </>
  );
};
export default EmptyState;
